module.exports = __webpack_public_path__ + "static/media/k_white.d4305f6c.png";